export default [{
	path: '/oldPeopleHome',
	component: () => import('../../views/oldPeopleHome'),
	redirect: '/oldPeopleHome/home',
	children: [{
			path: 'home',
			component: () => import('../../views/oldPeopleHome/home')
		}
	]
}]